// extracted by mini-css-extract-plugin
export var errorIcon = "_oq-1";
export var nameLogo = "_oq-0";